import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./auth";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div data-testid="protected-loading" className="min-h-screen flex items-center justify-center bg-[#050505]">
        <div className="mono-font text-sm text-white/50 tracking-widest uppercase pulse-glow">
          Authenticating cryptographic session…
        </div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}
